module.exports = __webpack_public_path__ + "img/1-3.c5edf9d8.svg";